'use strict';

var ES6Promise = require('es6-promise').Promise;
var generate = require('./promish-class');
module.exports = generate(ES6Promise);
//# sourceMappingURL=es6-promish.js.map



//////////////////
// WEBPACK FOOTER
// ./~/promish/dist/promish-node.js
// module id = 1745
// module chunks = 0